import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SendDownloadLinkRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SendDownloadLinkResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const sendDownloadLink = (request: SendDownloadLinkRequest, options?: CashRequestOptions) =>
  post<SendDownloadLinkRequest, SendDownloadLinkResponse>('/2.0/cash/send-download-link', request, {
    ...options,
    rejectOnError: true,
  })
